export default __webpack_public_path__ + "static/media/motorbike.c463725f.svg";